<div [formGroup]="form" class="form-group field" style="min-width: 180px" #opTarget>
  <p-float-label>
    <p-inputgroup class="w-full">
      <input
        type="text"
        pInputText
        [(ngModel)]="inputValue"
        [ngModelOptions]="{ standalone: true }"
        (blur)="onBlur($event)"
        [readOnly]="readonly"
      />
      @if (label) {
        <label for="dateControl" class="block"
          >{{ label }}
          @if (attribute?.displayNameSuffixIcon) {
            <i inline style="font-size: small">{{ attribute.displayNameSuffixIcon }}</i>
          }
          @if (isRequired()) {
            <span style="color: red">*</span>
          }
        </label>
      }
      @if (!readonly) {
        <p-inputgroup-addon>
          <p-button severity="secondary" (click)="clear($event)" [icon]="defaultIcon.Clear"></p-button>
        </p-inputgroup-addon>
        <p-inputgroup-addon>
          <p-button
            severity="secondary"
            (click)="verifyInitialValue(); op.show($event, opTarget)"
            [icon]="defaultIcon.Time"
          >
          </p-button>
        </p-inputgroup-addon>
      }
    </p-inputgroup>
  </p-float-label>
  <ng-content></ng-content>
  <div>
    @if (displayHint || attribute?.displayHint) {
      <small class="block">
        {{ displayHint ? displayHint : attribute?.displayHint }}
      </small>
    }
    <s-form-error-input
      [groupName]="groupName"
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
    />
  </div>
</div>

<p-popover #op>
  <div class="flex flex-wrap flex-row items-center justify-center">
    <div class="justify-center w-16">
      <p-inputNumber
        [(ngModel)]="overlayHourValue"
        [showButtons]="true"
        buttonLayout="vertical"
        spinnerMode="vertical"
        inputId="vertical"
        inputStyleClass="w-16"
        decrementButtonClass="p-button-primary w-16"
        incrementButtonClass="p-button-primary w-16"
        (ngModelChange)="updateFromPartials()"
        [min]="0"
      />
    </div>
    <b class="vertical-align-middle text-xl">:</b>
    <div class="justify-center w-16">
      <p-inputNumber
        [(ngModel)]="overlayMinValue"
        [showButtons]="true"
        buttonLayout="vertical"
        spinnerMode="vertical"
        inputId="vertical"
        inputStyleClass="w-16"
        decrementButtonClass="p-button-primary w-16"
        incrementButtonClass="p-button-primary w-16"
        (ngModelChange)="updateFromPartials()"
      />
    </div>
  </div>
</p-popover>
